import { CONTRACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useGetAllowedActionsQuery } from '../../../../__generated__/chirp/com/hubspot/commerce/contracts/rpc/ContractActionService.hooks';
import { useQuerySelector } from 'utility-belt/hooks/useQuerySelector';
import { hasContractM1Gate } from '../../../utils/gates';
export function useAllowedActions({
  objectId,
  objectTypeId
}, options = {}) {
  return useQuerySelector(useFetchAllowedActions({
    objectId,
    objectTypeId
  }, options), data => data === null || data === void 0 ? void 0 : data.result);
}
export function useFetchAllowedActions({
  objectId,
  objectTypeId
}, options = {}) {
  return useGetAllowedActionsQuery(Object.assign({}, options, {
    notifyOnNetworkStatusChange: true,
    skip: options.skip || !objectId || objectId === -1 || objectTypeId !== CONTRACT_TYPE_ID || !hasContractM1Gate(),
    variables: {
      contractId: objectId
    }
  }));
}